import {NotificationMessage} from '@providers/notifications/notification-message';

/**
 * Сгруппированные по дате уведомления.
 * Основная структурная единица компонента уведомлений
 */
export class NotificationsGroup {
    constructor(
        /**
         * Дата уведомлений
         */
        public date: string,
        /**
         * Уведомления в группе
         * @type {any[]}
         */
        public items: NotificationMessage[] = [],
    ) {
    }

    /**
     * Возвращает Ids новых уведомлений (не прочитанных)
     * @returns {number[]}
     */
    public getNewItemsIds(): number[] {
        return this.items.filter(item => !item.isRead).map(item => item.id);
    }

    public removeItem(id: number) {
        const itemToRemove = this.items.find(item => item.id === id);

        if (!itemToRemove) {
            return;
        }

        this.items.splice(this.items.indexOf(itemToRemove), 1);
    }
}
